// src/components/DashboardList.jsx
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import supabase from "../lib/supabase";
import { useDashboardAccess } from "../hooks/useDashboardAccess";
import DashboardCard from "./DashboardCard";
import logo from "../assets/company_logo.png";

const METABASE_SITE_URL = process.env.REACT_APP_METABASE_SITE_URL;

export default function DashboardList({ session }) {
  const navigate = useNavigate();
  const user = session?.user;
  const userId = user?.id;

  const [email, setEmail] = useState(null);

  const { dashboards, loading, error, noAccess } = useDashboardAccess(userId);

  useEffect(() => {
    if (user?.email) setEmail(user.email);
  }, [user]);

  const openDashboard = (publicUuid) => {
    const url =
      `${METABASE_SITE_URL}/public/dashboard/${publicUuid}` +
      `?user_id=${session.user.id}` +
      `&bordered=false&titled=false&hide_parameters=true&hide_header=true&theme=night`;

    navigate("/dashboard/view", { state: { metabaseUrl: url } });
  };

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut({ scope: "local" });
      localStorage.clear();
      sessionStorage.clear();
      window.location.assign("/login");
    } catch (err) {
      console.error("Logout failed:", err);
      window.location.assign("/login");
    }
  };

  if (loading) return <div className="dashboard-fullscreen">Loading dashboards…</div>;

  return (
    <div className="dashboard-fullscreen">
      <button className="back-button" onClick={handleLogout}>⏻ Logout</button>
      <div className="dashboard-info-block">
        <img src={logo} alt="Logo" className="dashboard-logo-small" />

        {email && (
          <span className="dashboard-user">
            Logged in as: <strong>{email}</strong>
          </span>)}

          <span className="dashboard-contact"> Contact us: <strong>inquire@dashboard-iq.com</strong> | <strong>+27 82 562 8245</strong>
          </span>

      </div>
      <h1 className="dashboard-heading">Dashboard Catalogue</h1>

      {error && <p className="status-message error">Error loading dashboards: {error.message}</p>}
      {noAccess && <p className="status-message">No dashboards available for your account.</p>}

      {dashboards.length > 0 && (
        <div className="dashboard-grid">
          {dashboards.map((dashboard) => (
            <DashboardCard
              key={dashboard.id}
              dashboard={dashboard}
              onOpen={() => openDashboard(dashboard.public_uuid)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
